import { UniqueIdentifier } from '@dnd-kit/core';
import { OrderedColumnsT } from 'business/definitions';

export const conceptionAvailableVizTypes = [
    'bar',
    'horizontal_bar',
    'polar_bar',
    'line',
    'scatterplot',
    'area',
];

export type DraggableColumn = {
    id: string;
    chartDimensionKey: keyof OrderedColumnsT;
    isTree: boolean;
    isDiggingEnabled: boolean;
    diggingTooltipTitle: string;
};

export const isDimensionKey = (
    dimension: UniqueIdentifier | string,
): dimension is DraggableColumn['chartDimensionKey'] =>
    ['x', 'y', 'z'].includes(dimension.toString());
